import './nav.css'
import {
    NavLink,
} from 'react-router-dom';
import { BsPencil } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';


export default function NavItems({ isAdmin, calendarUrl, showPrices, showBlogs }) {

    const { t } = useTranslation();

 return (
   <>
     {!isAdmin ? (
       <>
         {t("nav_links", { returnObjects: true })
         .filter(item => {
          if (item === "prices" && !showPrices) return false;
          if (item === "blog" && !showBlogs) return false;
          return true;
        })
         .map((item) => {
           const urlPath = item.toLowerCase().replace(/\s+/g, "-"); 
           
           return (
             <li key={item}>
               <NavLink className="nav-link" to={`/${urlPath}`}>
               {t(item)}
               </NavLink>
             </li>
           );
         })}
        
       </>
     ) : (
       <>
         {t("nav_links_admin", { returnObjects: true }).map((item) => (
           <li key={item}>
             <NavLink className="nav-link" to={`edit/${item}`}>
               <span style={{ color: "white", paddingRight: "5px" }}>
                 <BsPencil size="15px" color='black'/>
               </span>
               {t(item)}
             </NavLink>
           </li>
         ))}
       </>
     )}
   </>
 );

}